import axios from 'axios'
const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL
export async function getConversation(userId) {
    try {
        const response = await axios.get(
            `${apiUrl}/chat/conversations/${userId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true, // Inclut les cookies dans la requête
            }
        )
        return response.data
    } catch (err) {
        console.error(err)
    }
}

export async function getUserThingConversations(thingId) {
    try {
        const response = await axios.get(
            `${apiUrl}/chat/conversations/thing/${thingId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true, // Inclut les cookies dans la requête
            }
        )
        return response.data
    } catch (err) {
        console.error(err)
    }
}

export async function createConversation(sellerId, thingId) {
    try {
        const response = await axios.post(
            `${apiUrl}/chat/conversations/`,
            {
                sellerId: sellerId,
                thingId: thingId,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true, // Inclut les cookies dans la requête
            }
        )
        return response
    } catch (err) {
        console.error(err)
        throw err // Rejette l'erreur pour que l'appelant puisse la gérer
    }
}

export async function getMessages(conversationId) {
    try {
        const response = await axios.get(
            `${apiUrl}/chat/messages/${conversationId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true, // Inclut les cookies dans la requête
            }
        )
        return response.data
    } catch (err) {
        console.error(err)
    }
}

export async function sendMessage(conversationId, message) {
    try {
        await axios.post(
            `${apiUrl}/chat/messages`,
            {
                conversationId: conversationId,
                message: message,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true, // Inclut les cookies dans la requête
            }
        )
        // Mettez à jour l'affichage des messages ou la liste des conversations ici si nécessaire
    } catch (err) {
        console.error("Erreur lors de l'envoi du message: " + err)
    }
}
